<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
========================================================================================== -->

<template>
  <v-tour :name="name" :steps="steps">
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.currentStep === index"
          v-for="(step, index) of tour.steps"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
        >

          <div slot="actions" class="flex justify-center">
            <vs-button
              size="small"
              class="mr-2 pl-3 pr-3"
              @click="finish"
              icon-pack="feather"
              icon="icon-x"
              icon-after
              color="#fff"
              type="border"
              v-if="tour.currentStep != tour.steps.length - 1">
              跳过
            </vs-button>

            <vs-button
              size="small"
              @click="tour.previousStep"
              icon-pack="feather"
              icon="icon-chevrons-left"
              color="#fff"
              type="border"
              class="mr-2 pl-3 pr-3"
              v-if="tour.currentStep">
              上一步
            </vs-button>

            <vs-button
              size="small"
              @click="tour.nextStep"
              icon-pack="feather"
              icon="icon-chevrons-right"
              icon-after
              color="#fff"
              type="border"
              class="btn-tour-next pl-3 pr-3"
              v-if="tour.currentStep != tour.steps.length - 1">
              下一步
            </vs-button>

            <vs-button
              size="small"
              @click="finish"
              icon-pack="feather"
              icon="icon-check-circle"
              icon-after
              color="#fff"
              type="border"
              class="btn-tour-finish"
              v-if="tour.currentStep == tour.steps.length - 1">
              完成
            </vs-button>
          </div>

        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
export default{
  name: 'vx-tour',
  props: {
    steps: {
      required: true,
      type: Array
    },
    name: {
      required: true,
      type: String
    }
  },
  watch: {
    '$route.path'() {
      this.tourStop()
    }
  },
  methods: {
    tourStart() {
      this.$tours[this.name].start()
    },
    tourStop() {
      this.$tours[this.name].stop()
    },
    finish() {
      localStorage.setItem(this.name + 'Done', 1)
      this.tourStop()
    }
  },
  mounted() {
    if(!localStorage.getItem(this.name + 'Done')) this.tourStart()
  }
}
</script>

<style lang="scss">
.v-tour {
  .v-step {
    z-index: 55000;
    background-color: rgba(var(--vs-primary),1);
    border-radius: .5rem;
    padding: 1.5rem;
    filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

    .v-step__arrow {
      border-color: rgba(var(--vs-primary),1);
    }

    .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
      border-color: rgba(255, 255, 255, .5) !important;
    }
  }
}
</style>
